<template>
  <div id="app" class="antialiased">
    <ClosedBeta></ClosedBeta>
  </div>
</template>

<script>
import ClosedBeta from "./components/ClosedBeta.vue";
export default {
  name: "app",
  components: {
    ClosedBeta,
  },
};
</script>

<style>
#app {
  position: absolute;
  left: 0px;
  top: 0px;
  font-family: "Avenir", -apple-system, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  height: 100vh;
  width: 100%;
  
}
/* *::-webkit-scrollbar {
  width: 12px;
}
*::-webkit-scrollbar-track {
  background: #22292d;
}
*::-webkit-scrollbar-thumb {
  background-color: #4299e1;
  border-radius: 20px;
  border: 4px solid #22292d;
} */
</style>